const mapping: Record<string, string> = {
  id: 'lsd=>lsd.Id',
  language: 'lsd=>lsd.Language',
  schemeId: 'lsd=>lsd.SchemeId',
}

export const mapSortLogSchemeDataParam = (key: string) => mapping[key]
